import {
  GET_CONTENT_SUCCESS, DELETE_CONTENT_REQUEST_SUCCESS
  , CHECK_ALL_CONTENT, CHECK_ONE_CONTENT,
  DELETE_ALL_CONTENT, UNCHECK_ONE_CONTENT,
  UNCHECK_ALL_CONTENT, ADD_CONTENT_REQUEST,
  DELETE_CONTENT_REQUEST, GET_CONTENT_REQUEST,
  ADD_CONTENT,
  ADD_CONTENT_FAILED,
  GET_CONTENT_FAILED,
  CONTENT_FLAG_OFF,
  SEARCHING,
  SEARCHING_END,
  CONTENT_SCHEDULE_SUCCESS,
  CONTENT_SCHEDULE_DELETE,
  CLIENT_CONTENT_SUCCESS,
  CONTENT_UPDATED,
  CONTENT_RENAMED,
  SET_CONTENT_PAGINATION,
  COUNT_OF_EACH_CONTENT_REQ,
  COUNT_OF_EACH_CONTENT_SUCCESS,
  CLEAR_CONTENT,
  ENTER_SUPPORT_CONTEXT,
  LEAVE_SUPPORT_CONTEXT
} from "../constant";

const initial = {
  isContentLoading: false,
  isDeleting: false,
  isDeleted: false,
  isContentAdding: false,
  contentLoading:false,
  isContentAdded: false,
  isContentUpdated:false,
  isContentScheduled: false,
  isContentScheduledDeleted: false,
  isContentLoaded:false,
  content: [],
  clientContent:[],
  content_stats:{},
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  }
};
export const ContentReducer = (state = initial, action) => {
  switch (action.type) {
    case ENTER_SUPPORT_CONTEXT:
    case LEAVE_SUPPORT_CONTEXT:
      // Never show one tenant's rows while another tenant's are loading.
      return { ...initial };
    case CONTENT_FLAG_OFF:
      return {
        ...state,
        isContentAdded: false,
        isContentScheduled: false,
        isContentScheduledDeleted: false,
        isDeleted: false,
        // keep isContentLoaded so UI (pagination etc) doesn't flicker/hide
        // isContentLoaded:false,
        contentLoading:false,
        isContentUpdated:false
      }
      case COUNT_OF_EACH_CONTENT_REQ:
        return {
          ...state,
          contentLoading:true,
        }
      case COUNT_OF_EACH_CONTENT_SUCCESS:
        return {
          ...state,
          contentLoading:false,
          content_stats:action.payload
        }
    case ADD_CONTENT_REQUEST:
      return {
        ...state,
        isContentAdding: true,
      };
    case ADD_CONTENT:
      const addedContents = Array.isArray(action.payload)
        ? action.payload
        : action.payload
        ? [action.payload]
        : [];
      const normalizedNew = addedContents.map((item) => ({
        ...item,
        checked: false,
      }));
      // Prepend so first page / newest-first matches API; avoid duplicates by id when re-fetching overlaps.
      const newIds = new Set(
        normalizedNew.map((c) => c.id).filter(Boolean)
      );
      const withoutDupes = state.content.filter(
        (c) => !newIds.has(c.id)
      );
      return {
        ...state,
        isContentAdding: false,
        isContentAdded: true,
        content: [...normalizedNew, ...withoutDupes],
      };
    case ADD_CONTENT_FAILED:
      return {
        ...state,
        isContentAdding: false,
      };
    case CLEAR_CONTENT:
      return {
        ...state,
        content: [],
        pagination: {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          itemsPerPage: state.pagination?.itemsPerPage ?? 10
        }
      };
    case GET_CONTENT_REQUEST:
      return {
        ...state,
        isContentLoading: true,
      };
    case GET_CONTENT_SUCCESS:
      let contentArr = [];
      const payload = action.payload;
      const content = payload.content || payload; // Handle both old and new format
      const pagination = payload.pagination;
      
      content.forEach((c) => contentArr.push({ ...c, checked: false }));
      return {
        ...state,
        isContentLoading: false,
        isContentLoaded:true,
        content: contentArr,
        pagination: pagination || state.pagination
      };
    case GET_CONTENT_FAILED:
      return {
        ...state,
        isContentLoading: false
      }
    case DELETE_CONTENT_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_CONTENT_REQUEST_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        isDeleted: true,
        content: state.content.filter((con) => con.id !== action.payload),
      };
    case CHECK_ALL_CONTENT:
      let checkAllContentArr = [];
      state.content.forEach((c) => checkAllContentArr.push({ ...c, checked: true }));
      return {
        ...state,
        content: checkAllContentArr,
      };
    case UNCHECK_ALL_CONTENT:
      let unCheckAllContentArr = [];
      state.content.forEach((c) => unCheckAllContentArr.push({ ...c, checked: false }));
      return {
        ...state,
        content: unCheckAllContentArr,
      };
    case CHECK_ONE_CONTENT:
      const checkOneContentIndex = state.content.findIndex((c) => c.id === action.payload);
      state.content[checkOneContentIndex] = {
        ...state.content[checkOneContentIndex],
        checked: true,
      };
      return {
        ...state,
        content: state.content,
      };
    case UNCHECK_ONE_CONTENT:
      const unCheckOneContentIndex = state.content.findIndex((c) => c.id === action.payload);
      state.content[unCheckOneContentIndex] = {
        ...state.content[unCheckOneContentIndex],
        checked: false,
      };
      return {
        ...state,
        content: state.content,
      };
    case DELETE_ALL_CONTENT:
      let deleteContentArr = [];
      action.payload.forEach((c) => deleteContentArr.push({ ...c, checked: false }));
      return {
        ...state,
        content: deleteContentArr
      };
    case CONTENT_SCHEDULE_SUCCESS:
      state.content[state.content.findIndex(c => c.id === action.payload._id)] = { ...action.payload };
      return {
        ...state,
        isContentScheduled: true,
        content: state.content
      }
    case CONTENT_SCHEDULE_DELETE:
      state.content[state.content.findIndex(c => c.id === action.payload._id)] = { ...action.payload };
      return {
        ...state,
        isContentScheduledDeleted: true,
        content: state.content
      }
    case CLIENT_CONTENT_SUCCESS:
      return {
        ...state,
        clientContent: action.payload
      }
    case CONTENT_RENAMED:
      return {
        ...state,
        content: state.content.map((c) =>
          c.id === action.payload.id ? { ...c, name: action.payload.name } : c
        ),
      };
    case CONTENT_UPDATED:

      const __findIndexForContentUpdate = state.content.findIndex(c => c.id === action.payload.id);
      state.content[__findIndexForContentUpdate] = { ...action.payload };
      return {
        ...state,
        content: state.content,
        isContentUpdated:true
      }
    default:
      return state;
  }
};
